import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { AppProviders } from './app/providers'
import './styles/global.css'
import './styles/compact.css'
import './styles/admin-v2.css'
import { initializePwaEnvironment } from './lib/pwa/environment'

initializePwaEnvironment()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><AppProviders><App /></AppProviders></React.StrictMode>,
)
